import axios from "axios";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import { ISoftwareVersionsRepository, SoftwareVersion, UpdateSoftwareVersionPayload } from "@domain/repositories/ISoftwareVersionsRepository";
import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";

@injectable()
export class SoftwareVersionsRepository implements ISoftwareVersionsRepository {
  @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;

  async ListAsync(enabled?: boolean): Promise<SoftwareVersion[]> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.softwareVersions}`;
    return this._requestHandlerService.handleRequestAsync<SoftwareVersion[]>(() => axios.get<SoftwareVersion[]>(url, { params: enabled === undefined ? undefined : { enabled } }));
  }

  async UpdateAsync(version: string, payload: UpdateSoftwareVersionPayload): Promise<SoftwareVersion> {
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.softwareVersionsVersion}`.replace("{version}", encodeURIComponent(version));
    return this._requestHandlerService.handleRequestAsync<SoftwareVersion>(() => axios.patch<SoftwareVersion>(url, payload));
  }
}
